export const messages = {
  en: {
    financialReport: {
      search: {
        title: 'Search Conditions',
        monthRange: 'Month Range',
        placeholderMonthRange: 'Please select month range',
        feeType: 'Fee Type',
        placeholderFeeType: 'Please select fee type',
        search: 'Search',
        reset: 'Reset'
      },
      table: {
        title: 'Financial Report',
        communityName: 'Community Name',
        hisOweFee: 'History Owe',
        curReceivableFee: 'Current Receivable',
        curReceivedFee: 'Current Received',
        curOweFee: 'Current Owe',
        totalOweFee: 'Total Owe',
        actualPaid: 'Actual Paid',
        feeRoomRate: 'Room Rate',
        feeRate: 'Fee Rate',
        clearRate: 'Clear Rate'
      },
      export: 'Export',
      fetchError: 'Failed to fetch financial report data'
    }
  },
  zh: {
    financialReport: {
      search: {
        title: '查询条件',
        monthRange: '月份范围',
        placeholderMonthRange: '请选择月份范围',
        feeType: '费用类型',
        placeholderFeeType: '请选择费用类型',
        search: '查询',
        reset: '重置'
      },
      table: {
        title: '财务报表',
        communityName: '小区名称',
        hisOweFee: '历史欠费',
        curReceivableFee: '当期应收',
        curReceivedFee: '当期实收',
        curOweFee: '当期欠费',
        totalOweFee: '总欠费',
        actualPaid: '实缴',
        feeRoomRate: '户收费率',
        feeRate: '缴费率',
        clearRate: '清缴率'
      },
      export: '导出',
      fetchError: '获取财务报表数据失败'
    }
  }
}
